//import OldStepper from './feature/Stepper/OldStepper'
// import CreateAccount from './feature/Stepper/newStepper/CreateAccount'
// import CreateAccount from './feature/Stepper/IframeStepper/CreateAccount'
// import CreateAccount from './feature/Stepper/Stepper2/CreateAccount'
import CreateAccount from './feature/Stepper/Stepper2Mexico/CreateAccount'
// import CreateAccount from './feature/Stepper/Stepper3/CreateAccount'

// import CreateAccount from './feature/Stepper/IframeCalcStepper/CreateAccount'
// import { Calculator } from './feature/Calculator/Calculator'




function App() {

  return <CreateAccount />
}

// function App() {
//   return (
//     <>
//     <Calculator />
//     <CreateAccount />
//     </>
//   )
// }

export default App
